var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-sector",class:{ last: _vm.isLast, first: _vm.isFirst }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }